import { SchedulePowerBi } from "../../models/business-intelligence/schedule-power-bi.model";

export class ListSchedulePowerBiRequest
{
    public listSchedulePowerBi: SchedulePowerBi[] = [];
}